import { PropsWithChildren } from "react";

const Text = ({ className, children }: PropsWithChildren<{ className?: string }>) => (
  <span className={className}>
    <span>{children}</span>
  </span>
);

export default Text;
